// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"37ba9ab1","453":"0adfc61d","732":"9fc022b0"}[chunkId] + ".chunk.js";
};